<template>
	<tr>
		<td>
			<b-link
				href="#"
				@click.prevent="onUpdateClick"
			>{{ clock.Name }}</b-link>
		</td>

		<td>{{ clock.CustomerName }}</td>

		<td>{{ formatDate(clock.ServiceContractDate) }}</td>
	</tr>
</template>
<script>
// import shared functions
import { dateFuncs } from "@/globs.js";

export default {
	name: "ClockListRow",

	props: ["clock"],

	methods: {
		onUpdateClick() {
			this.$emit("update", this.clock.Id);
		},

		formatDate(date) {
			return dateFuncs.humanDateFormat(date);
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/clock/clock-list-row.vue